import React, { useState } from 'react';
import { withRouter } from 'react-router';
import MainButton from '../../../components/UI/Buttons/MainButton/MainButton';
import MaterialInput from '../../../components/UI/Inputs/MaterialInput/MaterialInput';
import classes from './NewsSearch.module.css';

const queryString = require('query-string');

const NewsSearch = (props) => {
    const [input, setInput] = useState('');
    const searchNews = (event) => {
        event.preventDefault();
        const searchString = queryString.stringify({search_query: input}, {
            skipEmptyString: true,
            skipNull: true
        });
        
        props.history.push({
            pathname: '/news',
            search: searchString
        });
    }
    
    return (
        <div className={`${classes.NewsSearch} scaleIn`}>
            <form onSubmit={(event) => searchNews(event)}>
                <MaterialInput 
                    elementType='input'
                    elementConfig={{type: 'text'}}
                    value={input}
                    label='Ključna reč'
                    changed={event => setInput(event.target.value)}
                />
                <MainButton 
                    btntype="submit" 
                    clicked={(event) => searchNews(event)}
                >
                    Pretraži
                </MainButton>
            </form>
        </div>
    );
};

export default withRouter(NewsSearch);